import { YAxisOptions } from "highcharts";

export function addYAxisPipe(axis?: YAxisOptions) {
  return (options: Highcharts.Options): Highcharts.Options => {
    const hasYAxis = Boolean(options.yAxis);
      let yAxis: YAxisOptions | YAxisOptions[];
      const newAxis: YAxisOptions = { 
        min: 0,
        title: { text: undefined }, 
        ...axis 
      };
      if (hasYAxis) {
        yAxis = [] as YAxisOptions[];
        if (Array.isArray(options.yAxis!)) {
          yAxis = yAxis.concat(options.yAxis);
        } else {
          yAxis = [options.yAxis!];
        }
        yAxis.push(newAxis);
      } else {
        yAxis = newAxis;
      }

      return {
        ...options,
        yAxis,
      };
  };
}
